export default __webpack_public_path__ + "static/media/ICON7.fb5e94ad.svg";